module.exports = __webpack_public_path__ + "static/media/whiteLogo.bec3bf29.svg";